export default {"src":"/login-app/[GIT_HASH]/_next/static/media/attach_file.d82cef3a.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};